export default __webpack_public_path__ + "static/Pala_22-427347f233a861d9797e0833803f6631.png";